import { useFormik } from "formik";
import moment from "moment";
import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import CustomTable from "../../../Shared/CustomTable";
import CustomToPagination from "../../../Shared/Pagination";
import { apiConnectorGet, apiConnectorPost } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import { formatedDate, getFloatingValue } from "../../../utils/utilityFun";
import CustomTableSearch from "../../Shared/CustomTableSearch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
const DemoMemberList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [approvingId, setApprovingId] = useState(null);
  const [page, setPage] = useState(1);
  const [revealedPassIndex, setRevealedPassIndex] = useState(null);
  const client = useQueryClient();
  const initialValues = {
    search: "",
    count: 10,
    start_date: "",
    end_date: "",
  };

  const fk = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
  });
  const { data, isLoading } = useQuery(
    [
      "getdemo_member_list",
      fk.values.search,
      fk.values.start_date,
      fk.values.end_date,
      page,
    ],
    () =>
      apiConnectorPost(endpoint?.demo_member_list, {
        search: fk.values.search,
        created_at: fk.values.start_date,
        updated_at: fk.values.end_date,
        page: page,
        count: fk.values.count,
      }),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onError: (err) => console.error("Error fetching direct data:", err),
    },
  );

  const allData = data?.data?.result || [];

  const handleApprovePass = async (userId) => {
    setApprovingId(userId);
    try {
      const res = await apiConnectorPost(endpoint?.user_first_topup_by_admin, {
        user_id: userId,
      });
      if (res?.data?.success) {
        toast.success("Approved successfully");
        client.invalidateQueries([
          "getdemo_member_list",
          fk.values.search,
          fk.values.start_date,
          fk.values.end_date,
          page,
        ]);
      } else {
        toast.error(res?.data?.message || "Approval failed");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setApprovingId(null);
    }
  };

  const tablehead = [
    <span>S.No.</span>,
    <span>Email</span>,
    <span>Mobile</span>,
    <span>Customer Id</span>,
    <span>Name</span>,
    <span>Registration Date</span>,
    <span>Approve Pass</span>,
  ];
  const tablerow = allData?.data?.map((row, index) => {
    return [
      <span> {(page - 1) * (fk.values.count || 10) + index + 1}</span>,
      <span className="cursor-pointer text-cyan-400">
        {row.lgn_email || "N/A"}
      </span>,
      <span className="cursor-pointer text-cyan-400">
        {row.lgn_mobile || "N/A"}
      </span>,
      <span> {row.lgn_cust_id}</span>,
      <span className="cursor-pointer text-cyan-400">
        {row.lgn_name || "N/A"}
      </span>,

      <span> {formatedDate(moment, row.tr03_reg_date)}</span>,
      row.tr03_meta_pass_date === null ? (
        <button
          disabled={approvingId === row.tr03_reg_id}
          onClick={() => handleApprovePass(row.tr03_reg_id)}
          className="px-3 py-1 rounded text-xs font-semibold bg-green-600 hover:bg-green-500 disabled:opacity-50 disabled:cursor-not-allowed text-white transition-colors"
        >
          {approvingId === row.tr03_reg_id ? "Processing..." : "Approve Pass"}
        </button>
      ) : (
        <span className="px-3 py-1 rounded text-xs font-semibold bg-gray-600 text-gray-300 cursor-not-allowed">
          Locked
        </span>
      ),
    ];
  });

  return (
    <div className="p-2">
      <CustomTableSearch
        fk={fk}
        onClearFn={() => {
          setPage(1);
        }}
        onSubmitFn={() => {
          setPage(1);
          client.invalidateQueries(["get_member_list"]);
        }}
      />

      {/* Table Section */}
      <div
        className="
        rounded-lg py-3
        text-white
        bg-black
        border border-gray-700
        shadow-md shadow-white/20
      "
      >
        <CustomTable
          tablehead={tablehead}
          tablerow={tablerow}
          isLoading={isLoading || loading}
        />

        {/* Total Income */}
        {/* <div className="flex justify-end py-3 text-sm font-semibold text-green-400">
          Total Income : $ {allData?.totalAmount || 0}
        </div> */}

        {/* Pagination */}
        <CustomToPagination page={page} setPage={setPage} data={allData} />
      </div>
    </div>
  );
};

export default DemoMemberList;
